export const AVAILABLE_DATES_KEY = 'available_dates';
export const AVAILABLE_TIME_RANGES_KEY = 'available_time_ranges';
export const BLANK_VALUE = '-';
export const BOOK_APPOINTMENT_MUTATION_KEY = 'book-appointment';
export const CALENDAR_MONTH_FORMAT = 'yyyy-MM';
export const CANCEL_APPOINTMENT_QUERY_KEY = 'cancel-appointment';
export const CREATE_REFERRAL_QUERY_KEY = 'create-referral';
export const DECLINE_REFERRAL_QUERY_KEY = 'decline-referral';
export const FIND_PARENT_ID_KEY = 'referrals';
export const GENETIC_COUNSELING_TRANSLATION = 'genetic_counseling';
export const PAGE_SIZE = 25;
export const PATIENT_HISTORY_KEY = 'patient_history';
export const PATIENT_PROFILE_QUERY_KEY = 'patient_profile';
export const REFERRALS_QUERY_KEY = 'referrals';
export const REGISTER_CONTACT_ATTEMPT_MUTATION_KEY = 'contact-attempt';
export const REOPEN_APPOINTMENT_QUERY_KEY = 'reopen-appointment';
export const UPDATE_PATIENT_PROFILE_KEY = 'update-patient-profile';
